const {h, render, Component} = require('preact');
const PureComponent = require('./../../helpers/pure_component');


class Click2CallCommentsView extends PureComponent {
    constructor(props) {
        super(props);
        this.changeCommentBoxState = this.changeCommentBoxState.bind(this);
    }

    readInput() {
      return document.getElementById("v2-textarea-input").value.trim();
    }

    changeCommentBoxState() {
      this.props.changeCommentBoxState(this.readInput(), true);
    }

    componentDidMount() {
      var commentBox = document.getElementById("v2-textarea-input")
      commentBox.addEventListener("keyup", this.changeCommentBoxState)
    }

    render() {
        return (
            <div class="form-v2-1">
                <div class="gig-field inputField comment-box focused">
                    <label for="v2-textarea-input" class="label-textarea">{I18n.translate("js.modules.support.comments")} <span class="optional">{I18n.translate('js.modules.support.optional')}</span></label>
                    <textarea class="text_line_input" id="v2-textarea-input" name="novel" rows="4" placeholder={I18n.translate('js.modules.support.call_back_quick_idea')}></textarea>
                </div>
            </div>
        )
    }
}

module.exports = Click2CallCommentsView